import { AnyAction } from 'redux'
import { createSelector } from 'reselect'

import { CONTENT_UPDATE } from 'client/store/constants'

const initialState: State.FacetState = {
  byId: {},
}

export function reducer(state: State.FacetState = initialState, action: AnyAction): State.FacetState {
  switch (action.type) {
    case CONTENT_UPDATE:
      return {
        ...state,
        byId: action.payload.facets.byId,
      }
    default:
      return state
  }
}

export const facetByIdSelector = createSelector(
  (state: State.GlobalState) => state.facets,
  (facets) =>
    (facet: string): Gallery.ContentQuery.Facet =>
      facets.byId[facet.toLowerCase()],
)
